/**
 * 管理后台 - 活动嘉宾 API
 */

import { httpGet, httpPost, httpPut, httpDelete } from '@/services/http';

/** 活动嘉宾关联接口 */
export interface EventGuest {
  id?: number;
  event_id: number;
  guest_id: number;
  role?: string;
  role_en?: string;
  topic?: string;
  topic_en?: string;
  sort_order?: number;
  guest?: {
    id: number;
    name: string;
    name_en?: string;
    title?: string;
    institution?: string;
    avatar?: string;
  };
  created_at?: string;
  updated_at?: string;
}

/** GET /api/admin/event-guests - 获取活动的所有嘉宾 */
export async function getEventGuests(eventId: number): Promise<EventGuest[]> {
  try {
    const data = await httpGet<EventGuest[]>(`/admin/event-guests?event_id=${eventId}`);
    return data || [];
  } catch (error) {
    console.error('获取活动嘉宾失败:', error);
    return [];
  }
}

/** POST /api/admin/event-guests - 添加活动嘉宾 */
export async function createEventGuest(data: Partial<EventGuest>): Promise<EventGuest | null> {
  try {
    return await httpPost<EventGuest>('/admin/event-guests', data);
  } catch (error) {
    console.error('添加活动嘉宾失败:', error);
    throw error;
  }
}

/** PUT /api/admin/event-guests/:id - 更新活动嘉宾 */
export async function updateEventGuest(id: number, data: Partial<EventGuest>): Promise<EventGuest | null> {
  try {
    return await httpPut<EventGuest>(`/admin/event-guests/${id}`, data);
  } catch (error) {
    console.error('更新活动嘉宾失败:', error);
    throw error;
  }
}

/** DELETE /api/admin/event-guests/:id - 移除活动嘉宾 */
export async function deleteEventGuest(id: number): Promise<boolean> {
  try {
    await httpDelete(`/admin/event-guests/${id}`);
    return true;
  } catch (error) {
    console.error('移除活动嘉宾失败:', error);
    throw error;
  }
}
